import React from "react";
import { kozijnSettings } from "shared/utils/doorConfigurations";
import { MeshBasicMaterial } from "three";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFrameScaling,
  getKozijnFramePositions,
} from "../../../../../shared/utils/door";
import { defaultDoorWidth } from "shared/utils/doorSceneConstants";

import { store } from "shared/store/store";
import { useSnapshot } from "valtio";

interface KozijnProps extends kozijnSettings {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
  existingFrame: boolean;
  widths: number[];
  option: "single" | "double";
}

const Kozijn: React.FC<KozijnProps> = ({
  doorNodes,
  materials,
  existingFrame,
  index,
  widths,
  option,
  ...props
}: KozijnProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getKozijnFramePositions(widths, height, option);
  const scaling = getFrameScaling(
    widths.reduce((a, c) => a + c, 0),
    height,
    widths.length,
  );

  const xScalingTop =
    width - defaultDoorWidth < 0
      ? scaling.horizontal.x +
        (1 - scaling.horizontal.x) * ((60 / width) * scaling.horizontal.x)
      : scaling.horizontal.x -
        (1 - scaling.horizontal.x) * ((30 / width) * scaling.horizontal.x);

  const material = existingFrame
    ? new MeshBasicMaterial({ color: "#FFF9DD" })
    : materials[getConfigurationColor()];

  return (
    <group>
      <group scale-y={props?.kozijnLeft?.scaleY ?? 1}>
        <mesh
          geometry={doorNodes["kozijn_left"].geometry}
          material={material}
          scale={scaling.vertical}
          position={props?.rotateKozijn ? positions.right : positions.left}
        ></mesh>
      </group>
      <group scale-y={props?.kozijnRight?.scaleY ?? 1}>
        <mesh
          geometry={doorNodes["kozijn_right"].geometry}
          material={material}
          scale={scaling.vertical}
          position={props?.rotateKozijn ? positions.left : positions.right}
        ></mesh>
      </group>
      <mesh
        geometry={doorNodes["kozijn_top"].geometry}
        material={material}
        scale={[xScalingTop + 0.01, scaling.horizontal.y, scaling.horizontal.z]}
        position={positions.top}
      ></mesh>
    </group>
  );
};

export default Kozijn;
